import './Tooltip.css';

export default function Tooltip({
  children,
  content,
  placement = 'top',
  variant = 'default',
}) {
  if (!content) return children;

  return (
    <span className={`suarte-tooltip suarte-tooltip--${placement} suarte-tooltip--${variant}`}>
      {children}
      <span className="suarte-tooltip__content" role="tooltip">{content}</span>
    </span>
  );
}
